const nonEditableStyle = {
  color: '#666',
  background: '#f5f5f5',
};

export const createTextCell = (value, isDisabled) => ({
  type: 'text',
  text: value !== undefined ? String(value) : '',
  nonEditable: isDisabled,
  style: isDisabled ? nonEditableStyle : undefined,
});

export const createNumberCell = (value, isDisabled) => ({
  type: 'number',
  value: value !== undefined && value !== '' ? Number(value) : NaN,
  nanToZero: true,
  nonEditable: isDisabled,
  style: isDisabled ? nonEditableStyle : undefined,
});

// 브라우저 언어와 무관하게 항상 YYYY-MM-DD로 표시
const DATE_DISPLAY_FORMAT = new Intl.DateTimeFormat('en-CA');

export const createDateCell = (value, isDisabled) => ({
  type: 'date',
  date: value ? new Date(value) : undefined,
  format: DATE_DISPLAY_FORMAT,
  nonEditable: isDisabled,
  style: isDisabled ? nonEditableStyle : undefined,
});

export const createDropdownCell = (
  value,
  options,
  isDisabled,
  isOpen = false,
) => ({
  type: 'dropdown',
  selectedValue: value !== undefined ? String(value) : '',
  values: options,
  isOpen: isOpen,
  nonEditable: isDisabled,
  style: isDisabled ? nonEditableStyle : undefined,
});

export const createCheckboxCell = (checked, isDisabled) => ({
  type: 'checkbox',
  checked: checked,
  nonEditable: isDisabled,
  style: isDisabled ? nonEditableStyle : undefined,
});
